<template>
  <div
    class="installment-option-box"
    :class="{ mobile: isMobile(), loading: loadingValues }"
    :style="`--times-content: \'${installmentNumber} vezes\'`"
  >
    <div class="installment-option-inner-box" :class="{ mobile: isMobile() }">
      <div class="installment-option-box-value" :class="{ mobile: isMobile() }">
        <span class="body-bold primary">
          {{ installmentValue | moneyFilter }}
        </span>
        <div class="por-mes" v-if="!loadingValues">
          por mês
        </div>
      </div>
      <div v-if="isMobile()" class="installment-option-box-number">
        {{ installmentNumber }} vezes
      </div>
      <div class="installment-option-box-info">
        <p class="info-interest" :class="{ mobile: isMobile() }">Juros {{ interest }}% a.m.</p>
        <p class="info-total-value">Total de {{ totalValue | moneyFilter }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import StringMixin from '@/mixins/string';
import UtilMixin from '@/mixins/util';

export default {
  name: 'down-payment-box',
  mixins: [StringMixin, UtilMixin],
  props: {
    installmentNumber: {
      type: Number,
      required: true,
    },
    installmentValue: {
      type: Number,
      required: true,
    },
    interest: {
      type: Number,
      required: true,
    },
    totalValue: {
      type: Number,
      required: true,
    },
    loadingValues: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.installment-skeleton {
  @extend .skeleton;
  height: 18px;
  color: transparent !important;

  span {
    color: transparent !important;
  }
}

.por-mes {
  display: inline;
  font-size: var(--font-size-sm);
  color: var(--gray-500);
}

.installment-option-box {
  display: flex;
  flex-direction: column;
  width: 31%;
  position: relative;

  &::after {
    @extend .small-semibold;
    @extend .white;

    content: var(--times-content);
    padding: 0 10px;
    background: var(--primary-dark);
    height: 24px;
    width: 76px;
    border-radius: 12px;
    position: absolute;
    top: -12px;
    left: 42px;

    text-align: center;
    vertical-align: middle;
    line-height: 24px;
  }

  .installment-option-inner-box {
    background: var(--white);
    border: 1px solid var(--gray-200);
    border-radius: 4px;
    padding: 12px;
    height: 93px;
    position: relative;

    &.mobile {
      height: auto;
    }

    span {
      @extend .body-bold;
      @extend .primary;
    }

    .installment-option-box-value {
      @extend .small-regular;
      @extend .gray-400;
      text-align: left;
      margin: 12px 0px 8px 0px;
      &.mobile {
        margin: 0;
        margin-bottom: 9px;
      }
    }

    .info-interest {
      @extend .x-small-regular;
      @extend .gray-500;
      text-align: left;
      &.mobile {
        font-weight: 600;
      }
    }

    .info-total-value {
      @extend .x-small-semibold;
      @extend .gray-700;
      text-align: left;
      margin-top: 4px;
    }
  }

  &.loading {
    .installment-option-box-value, .info-interest {
      @extend .installment-skeleton;
      width: 80%;
    }

    .info-total-value {
      @extend .installment-skeleton;
      width: 40%;
    }

    &::after {
      color: transparent !important;
    }
  }

  &.mobile {
    width: 100%;

    .installment-option-inner-box {
      display: grid;
      grid-template-columns: 3fr 1fr;
      grid-template-areas:
        'price installment'
        'info  installment';

      .installment-option-box-value {
        grid-area: price;
      }

      .installment-option-box-info {
        grid-area: info;
      }

      .installment-option-box-number {
        grid-area: installment;
        align-self: center;
      }
    }

    &::after {
      content: none;
    }

    &.loading {
      .installment-option-box-number {
        color: transparent;
      }
    }
  }
}

.installment-option-box-number {
  @extend .small-semibold;
  @extend .white;

  float: right;
  padding: 2px 10px;
  background: var(--primary-dark);
  height: 24px;
  width: 76px;
  border-radius: 12px;
  line-height: 24px;
}

</style>
